import React from 'react';
import { useStruttura, righeIntestazione, ragioneSociale } from '../../utils/struttura';

/*
 * L'intestazione in testa alle finestre della modulistica (accettazione,
 * firma dei consensi, completamento), che somigliano al modulo stampato.
 * I dati vengono dai parametri della struttura (utils/struttura.js): fino al
 * 29/10/2026 erano quelli di Rimedical scritti a mano in tre file.
 */
const IntestazioneModulo = ({ contatti = false }) => {
    const s = useStruttura();
    const righe = righeIntestazione(s, { contatti });
    return (
        <header className="modulo-intestazione">
            <div className="intestazione-ragione">{ragioneSociale(s)}</div>
            <div className="intestazione-righe">
                {righe.map((r, n) => (
                    <React.Fragment key={n}>{n > 0 && <br />}{r}</React.Fragment>
                ))}
            </div>
        </header>
    );
};

export default IntestazioneModulo;
